// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  capchaSiteKey: '6LfHOdQiAAAAANe1Z22uODRm2iCabRL2t5p9tiMM',
  baseUri:'https://r1apimdev01.azure-api.net/FCReferral/',
  subscriptionKey: 'd4be0abce4b84fafab20572ca22e4709'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
